// eslint-disable-next-line import/order

import { AuthProvider } from 'react-oidc-context';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import NotFoundPage from '../pages/errors/not-found';
import { PageLayout } from '../pages/pageLayout';
import { Login } from 'pages/login';
import { RequestRecovery, RequestRecoverySent } from 'pages/requestRecovery';
import { ResetPassword, ResetPasswordInvalid, ResetPasswordSuccess } from 'pages/resetPassword';
import { TinyLogin } from 'pages/tiny/login/login';

const oidcConfig = {
  authority: 'https://accounts.tiny.com.br/realms/tiny/',
  client_id: 'tiny-webapp',
  redirect_uri: 'https://erp.tiny.com.br/',
};

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="auth">
          <Route
            path="tiny"
            element={
              <AuthProvider {...oidcConfig}>
                <TinyLogin />
              </AuthProvider>
            }
          />
          <Route
            path="login"
            element={
              <PageLayout>
                <Login />
              </PageLayout>
            }
          />
          <Route
            path="request-recovery"
            element={
              <PageLayout>
                <RequestRecovery />
              </PageLayout>
            }
          />
          <Route
            path="request-recovery-sent"
            element={
              <PageLayout>
                <RequestRecoverySent />
              </PageLayout>
            }
          />
          <Route
            path="reset-password"
            element={
              <PageLayout>
                <ResetPassword />
              </PageLayout>
            }
          />
          <Route
            path="reset-password-success"
            element={
              <PageLayout>
                <ResetPasswordSuccess />
              </PageLayout>
            }
          />
          <Route
            path="reset-password-invalid"
            element={
              <PageLayout>
                <ResetPasswordInvalid />
              </PageLayout>
            }
          />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
